import React from 'react';
import RegisterPage from '@/pages/RegisterPage';
import Pricing from '@/pages/Pricing';
import Support from '@/pages/Support';
import PaymentCancel from '@/pages/PaymentCancel';
import PaymentSuccess from '@/pages/PaymentSuccess';
import ReferralPage from '@/components/ReferralPage';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import { StaticRouteConfig, LazyRouteConfig } from './types';

// Lazy loaded public pages
const Business = React.lazy(() => import('@/pages/Business'));
const Science = React.lazy(() => import('@/pages/Science'));
const Theory = React.lazy(() => import('@/pages/Theory'));
const Theory2 = React.lazy(() => import('@/pages/Theory2'));
const Theory3 = React.lazy(() => import('@/pages/Theory3'));
const Theory21 = React.lazy(() => import('@/pages/Theory21'));
const ProfilesPage = React.lazy(() => import('@/pages/ProfilesPage'));
const NewCompany = React.lazy(() => import('@/pages/NewCompany'));
const AddCompany = React.lazy(() => import('@/pages/AddCompany'));
const CompanyRegisterPage = React.lazy(() => import('@/pages/CompanyRegisterPage'));
const SignupInvitation = React.lazy(() => import('@/pages/SignupInvitation'));
const TrainingPublic = React.lazy(() => import('@/pages/TrainingPublic'));
const WordIntensityValidation = React.lazy(() => import('@/pages/WordIntensityValidation'));
export const staticPublicRoutes: StaticRouteConfig[] = [
  { path: '/register', component: RegisterPage },
  { path: '/pricing', component: Pricing },
  { path: '/support', component: Support },
  { path: '/payment-cancel', component: PaymentCancel },
  { path: '/payment-success', component: PaymentSuccess },
  { path: '/privacy', component: PrivacyPolicy },
  { path: '/terms', component: TermsOfService },
  { path: '/referral', component: ReferralPage },
];

const SharedProfilePage = React.lazy(() => import('@/pages/SharedProfilePage'));

export const lazyPublicRoutes: LazyRouteConfig[] = [
  { path: '/business', component: Business },
  { path: '/science', component: Science },
  { path: '/theory', component: Theory },
  { path: '/theory2', component: Theory2 },
  { path: '/theory3', component: Theory3 },
  { path: '/theory21', component: Theory21 },
  { path: '/register/:companySlug', component: CompanyRegisterPage },
  { path: '/profiles', component: ProfilesPage },
  { path: '/signup', component: NewCompany },
  { path: '/signupinvitation', component: SignupInvitation },
  { path: '/new-company', component: NewCompany },
  { path: '/companies/new', component: AddCompany },
  { path: '/add-company', component: AddCompany },
  { path: '/training-public', component: TrainingPublic },
  { path: '/word-validation', component: WordIntensityValidation },
  { path: '/profile/:nameSlug/:submissionId', component: SharedProfilePage },
];
